<template>
	<div :key="courseId" class="row page-heading pg_hd" v-if="permission && permission.version === '5'">

		<div class="col-7 input module_heading">
			<course-nav-menu
				:course-id="courseId"
				v-if="!course.showDeadLine || !isStudentLogin">
			</course-nav-menu>
      <template v-if="isCurate">
				<input
					type="text"
					v-model="course.title"
					v-bind:aria-label="course.title"
					style="width: 92%;"/>
      </template>
      <template v-else>
          <h1
						class="head_txt module_type_name ace_sec_hd"
						role="heading"
						aria-level="1">
							{{ course.title }}
					</h1>
          <template v-if="course.master">
						<span
							class="icon-master"
							:aria-label="$t('masterCourse')"
							:title="$t('masterCourse')"
							v-b-tooltip.hover>
							m
						</span>
          </template>
      </template>
		</div>

		<div class="col-5 float-right px-0" v-show="!isAdvisorViewingReport">
			<div v-if="isStudentLogin && !isOpenCourse" class="micro-competency-btn">
				<micro-competency-summary :entity-id="course.uuid"></micro-competency-summary>
			</div>
			<div class="submit btn-container" v-show="!showLastActivity">
				<template v-if="isStudentLogin && isOpenCourse && course.lmsCourseId">
					<!--
					<a :href="bblmslink()" target="_blank" class="btn">
						<i class="iconLms_Blackboard"></i>
						<span>goto LMS</span>
					</a>
					-->
				</template>
				<template v-if="isCurate">
	        <button
						class="btn-cancel"
						@click="cancel"
						:disabled="submitted"
						:aria-label="$tf('cancelAria')"
						:title="$tf('cancelTitle')"
						v-b-tooltip.hover>
							<span class="icon-cross"></span>
	        </button>
					<button
						class="btn btn-primary"
						@click="done"
						:disabled="submitted"
						:aria-label="$tf('doneAria')">
							{{ $tf('done') }}
					</button>
					<button
						class="btn btn-primary"
						@click="save"
						:disabled="submitted"
						:aria-label="$tf('saveAria')">
							{{ $tf('save') }}
					</button>
					<button
						class="btn btn-primary"
						@click="autonumber"
						:disabled="submitted"
						:aria-label="$tf('saveAndRenumber')">
							{{ $tf('saveAndRenumber') }}
					</button>
				</template>
				<template v-else>
  				<template v-if="isStudentLogin">
				    <!--
						<b-button
							v-if="continueLearning && continueLearning.uuid"
							:to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: 'LearningContent', entityUuid: continueLearning.uuid, subTopicUuid: continueLearning.ancestor, action: 'clickShowToc' } }"
							variant="primary"
							style="float:right;"
							class="btn_show_toc"
							:aria-label="LABELS.SHOW_TOC">
								{{LABELS.SHOW_TOC}}
						</b-button>
						-->
  				</template>
					<template v-else>
						<template v-if="permission.institutionPermission.canCreateCourses || course.menuToInstructor">
							<b-dropdown right animation="animation" variant="link" no-caret class="create-section-menu" ref="menuDropDown">
                  <template slot="button-content">
										<!--span class="icon-menu3x3" aria-label="dropdown menu"></span-->
										<span class="btn ic_btn">
											<span
												class="ic ic_more"
												:aria-label="$tf('dropdownMenuAria')"
												:title="$tf('moreActionBtnTitle')"
												v-b-tooltip.hover>
											</span>
										</span>
									</template>
                  <template v-if="course.master">
										<b-dropdown-item
											:to="{ name: 'courseSectionCreate', params: { sourceId: course.uuid } }"
											:disabled="(isSandboxUser || permission.systemPermission.readOnly)"
											:aria-label="$tf('createSectionFromMasterAria')">
											{{ $tf('createSectionFromMaster') }}
										</b-dropdown-item>
                  </template>
                  <template v-else>
                      <b-dropdown-item
												:to="{ name: 'courseCreate', params: { sourceId: course.uuid } }"
												:disabled="(isSandboxUser || permission.systemPermission.readOnly)"
												:aria-label="$tf('createMasterFromSectionAria')">
													{{ $tf('createMasterFromSection') }}
											</b-dropdown-item>
                  </template>
                  <template v-if="allowDownloadCTree">
                    <b-dropdown-item
											:aria-label="$tf('downloadCompetencyTreeAria')"
											@click="exportCourseCompetencyTree">
												{{ $tf('downloadCompetencyTree') }}
										</b-dropdown-item>
                  </template>
                  <template v-if="course.version !=='V2'">
                    <b-dropdown-item
											@click="downloadConversionDryRun"
											:aria-label="$tf('analyzeForConversionToModularAria')">
												{{ $tf('analyzeForConversionToModular') }}
										</b-dropdown-item>
                    <b-dropdown-item
										@click="uploadMCMapping"
										:aria-label="$tf('uploadMCMappingAria')">
											{{ $tf('uploadMCMapping') }}
										</b-dropdown-item>
                    <b-dropdown-item
											@click="showCourseUnbundleModal"
											:aria-label="$tf('downloadCompetencyTreeAria')">
												{{ $tf('unbundleMCs') }}
										</b-dropdown-item>
                    <b-dropdown-item
										@click="doConvertionToModular"
										:aria-label="$tf('convertCourseToModularAria')">
											{{ $tf('convertCourseToModular') }}
										</b-dropdown-item>
									</template>

									<add-app-proxy :parent="this" :context-id="courseId"></add-app-proxy>
								</b-dropdown>
							</template>

    				<b-button
							type="button"
							:to="{ name: 'courseLearn', params: { uuid: course.uuid } }"
							variant="primary"
							style="float:right;"
							class="btn_show_toc ace_sec"
							:aria-label="LABELS.SHOW_TOC">
								{{ LABELS.SHOW_TOC }}
						</b-button>

						<template v-if="(canEdit && permission.institutionPermission.canCreateCourses) || !donotAllowForCourse('Do not allow Course Edit')">
    				  <b-button
								:disabled="(isSandboxUser || permission.systemPermission.readOnly)"
								v-if="course.master" :to="{ name: 'courseEdit', params: { uuid: course.uuid } }"
								variant="primary"
								:style="{'float': 'right', 'margin-right': '12px', 'background': (permission.systemPermission.readOnly ? '#ccc' : '')}"
								class="btn_show_toc"
								:aria-label="$tf('editAria')">
									{{ $tf('edit') }}
							</b-button>
							<b-button
								:disabled="(isSandboxUser || permission.systemPermission.readOnly)"
								v-else :to="{ name: 'courseSectionEdit', params: { uuid: course.uuid } }"
								variant="primary" :style="{'float': 'right', 'margin-right': '12px', 'background': (permission.systemPermission.readOnly ? '#ccc' : '')}"
								class="btn_show_toc"
								:aria-label="$tf('editAria')"
								:title="$tf('editTitle')"
								v-b-tooltip.hover>
									{{ $tf('edit') }}
							</b-button>
						</template>
						<b-button
							type="button"
							class="ace_sec"
							:disabled="(isSandboxUser || permission.systemPermission.readOnly)"
							@click="naviagteToCourseCuration"
							variant="primary"
							:style="{'float': 'right', 'margin-right': '12px', 'background': (permission.systemPermission.readOnly ? '#ccc' : '')}"
							:aria-label="$tf('curateAria')"
							v-if="!donotAllowForCourse('Do not allow Course Curation')">
								{{ $tf('curate') }}
						</b-button>
            <template v-if="!isStudentLogin && allowCopyLTILink">
              <copy-to-clipboard :text="generateLTIUrl(course.uuid)">
              	<b-button
									:disabled="(isSandboxUser || permission.systemPermission.readOnly)"
									@click="notifyUrlCopiedMessage('LTI')"
									variant="primary" :style="{'float': 'right', 'margin-right': '12px', 'background': (permission.systemPermission.readOnly ? '#ccc' : '')}"
									:aria-label="$tf('curateAria')"
									:title="$tf('CopyLtiUrlForCourse')"
									v-b-tooltip.hover>
									lti url <span class="ic ic22-copy"></span>
								</b-button>
              </copy-to-clipboard>
            </template>

            </template>
            <template v-if="!isStudentLogin && !course.showDeadline">
				      <b-button
								@click="hideToc"
								variant="primary"
								style="float:right;"
								class="btn_hide_toc hideBtn ace_sec"
								:aria-label="$tf('hideToc')">
									{{ LABELS.HIDE_TOC }}
							</b-button>
				      <b-button
								@click="showToc"
								variant="primary"
								style="float:right;"
								class="showBtn ace_sec"
								:aria-label="$tf('showToc')">
									{{ LABELS.SHOW_TOC }}
								</b-button>
            </template>
				</template>
			</div>
		</div>
        <div class="loading-spinner" v-show="loading">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
                </div>
            </b-modal>
        </div>
<!-- Unbundle Model -->

    <div class="">
      <b-modal ref="courseUnbundleModal" class="modal__v22_2" size="lg" id="course-report-popup">
        <div slot="modal-header" class="row header-section w-100">
					<div class="col-11 hd">
						<div class="ic_container">

						</div>
						<div class="hd_txt">
							<span>
								{{ $tf('preparingToUnbundleMicroCompetencies') }}
							</span>
						</div>
					</div>
					<div class="col-1 btn_container pr-0 mt-0">
						<button class="btn_close" aria-label="close" @click="closeCourseUnbundleModal">
							 <span class="ic-close"></span>
						</button>
					</div>
				</div>

				<div class="row">
					<div class="col-11 popup_content" style="margin: 0 auto;">

						<div class="row sub_hd">
							<div class="col-12">
								Specify the default subject and topic tags for the MCs in this course
							</div>
						</div>

						<div class="modal_flds_container">

							<div class="row fld_row mb-3">
								<div class="col-2 fld_label">
									 Subject
								 </div>
								 <div class="col-8 fld_input">
									 <select id="folder" v-model="code1" aria-labelledby="folderName" style="width: 90%">
			               <option v-for="subject in subjects" :value="subject.subject">{{ subject.subject }}</option>
			             </select>
								</div>
							</div>

							<div class="row fld_row mt-1">
								<div class="col-2 fld_label">
									 Topic
								 </div>
								 <div class="col-8 fld_input">
									 <select id="folder" v-model="code2" aria-labelledby="folderName" style="width: 90%">
			               <option v-for="module in filteredModules" :value="module.module">{{ module.module }}</option>
			             </select>
								</div>
							</div>

						</div>

						<div class="row sub_hd mt-4">
							<div class="col-12">
								<strong>Note</strong>
							</div>
						</div>
						<div class="row txt_row mt-1">
	            <div class="col-12 fld_val" style="padding-left: 40px; line-height: 1.7rem;">
	              Have you uploaded the MC mapping CSV?<br />
	              If mapping has been uploaded, it will be used to unbundle the MCs.<br/>
	              If not, please upload the mapping before continuing the unbundling process.
							</div>
	          </div>


					</div>
				</div>

				<div slot="modal-footer" class="w-100">
					<b-button @click="closeCourseUnbundleModal" class="btn button-primary float-right mr-2"> cancel </b-button>
					<b-button @click="downloadExtract" class="btn button-primary float-right mr-2"> continue unbundling </b-button>
				</div>
      </b-modal>
    </div>
<!-- nWaive Model End-->
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AddAppProxy from './AddAppProxy'
import MicroCompetencySummary from './MicroCompetencySummary'
import CourseNavMenu from './CourseNavMenu'
import TOC from './TOC'
import TableOfContents from './TableOfContents'
import CopyToClipboard from 'vue-copy-to-clipboard'

export default {
  name: 'course-header',
  props: ['courseId', 'title', 'plan', 'canEdit', 'isCurate', 'showLastActivity', 'isAdvisorViewingReport', 'entityUuid'],
  data: () => {
    return {
      loading: false,
      submitted: false,
      subjects: [],
      modules: [],
      code1: 'MATH',
      code2:'',
      isStudentLogin: (localStorage.getItem('userrole') === 'Student'),
      isInstructorLogin: (localStorage.getItem('userrole') === 'Instructor'),
      sandboxUsers: ['demoinstructor2@nu.com', 'i1@csu.edu', 'i2@csu.edu', 'i1@vc.edu', 'i2@vc.edu', 'randolph.ward@teachforamerica.org', 'cassandra.zimmer@teachforamerica.org', 'caitlin.ormsby@teachforamerica.org', 'bkransberger@nu.edu', 'i1@lsc.edu', 'i1@pima.edu', 'trinaldi@nu.edu', 'jzavala@nu.edu'],
      isNuNavLogin: (window.location.host.indexOf('nunav') !== -1 || window.location.host.indexOf('competencyedu') !== -1 || window.location.host.indexOf('wsp') !== -1)
    }
  },
  mounted () {
      this.loadMicroCompetencySubjects().then(res => {
          this.subjects = res
      })
      this.loadMicroCompetencyModules().then(res => {
          this.modules = res
      })
  },
  components: {
    AddAppProxy,
    MicroCompetencySummary,
    CourseNavMenu,
    TOC,
    TableOfContents,
    CopyToClipboard
  },

  watch: {
    courseId (value) {
      this.$store.commit('LOAD_CONTINUE_LEARNING', {})
      if (value) {
        this.loadCourse()
      }
    }
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'saveCourseDetail',
      'autonumberContent',
      'loadLogDashboardActivity',
      'updateIsTocOpen',
      'exportCourseTreeToCsv',
      'exportCourseConversionToCsv',
      'convertCourseToModular',
      'unbundleMCFromCourse',
      'loadMicroCompetencySubjects',
      'loadMicroCompetencyModules'
    ]),

    closeMenuDropDown () {
      this.$refs.menuDropDown.hide(true)
    },

    bblmslink () {
      if (this.course && this.course.lmsCourseId) {
        return 'https://nu.blackboard.com/webapps/blackboard/execute/launcher?type=Course&id=_' + this.course.lmsCourseId + '_1&url='
      }
    },

    loadCourse () {
      this.loadCourseDetail(this.courseId)
      if (this.isTocOpen) {
        this.activateToc()
      }
    },

    cancel () {
      if (this.course.title.localeCompare(this.title) !== 0) {
        this.$store.commit('LOAD_COURSE', {})
      }
      return this.$router.push({ name: 'courseDashboardInstructor', params: { uuid: this.courseId } })
    },
    autonumber () {
      this.showLoader()
      this.submitted = true
      this.course.plan = this.generatePlan(this.plan)
      this.saveCourseDetail(this.course).then((res) => {
        this.autonumberContent(this.course).then((res) => {
          this.$emit('saved', JSON.parse(res.plan))
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Course "' + res.title + '" saved and tree re-numbered successfully.'
          })
          this.hideLoader()
          this.submitted = false
        })
      })
    },
    writeFile (data, fileName) {
      const blob = new Blob([data], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents')
      let a = document.createElement('a')
      a.download = fileName
      a.href = window.URL.createObjectURL(blob)
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      a.dispatchEvent(e)
    },
    async doConvertionToModular () {
          this.showLoader()
          let response = await this.convertCourseToModular({courseId:this.courseId, subject:this.code1, moduleName:this.code2})
          this.hideLoader()
          if(response==='Done'){
            this.notifySuccess('Course Successfully Converted to Modular Course.')
            this.$store.commit('LOAD_COURSE', {})
            this.$router.push({ name: 'courseDashboardInstructor', params: { uuid: this.courseId } })
          }else{
            this.notifyFailure(response)
          }
    },
    async downloadExtract (){
      this.showLoader()
      let response = await this.unbundleMCFromCourse({courseId:this.courseId, subject:this.code1, moduleName:this.code2})
      let summaryCsvFile = response && response.fileContents ? response.fileContents : response
      let errors = response && response.error ? response.error : ''
      let warnings = response && response.warning ? response.warning : ''
      if (!summaryCsvFile || !summaryCsvFile.length || summaryCsvFile.length === 0) {
        return this.notifyFailure(errors)
      }
      this.writeFile(summaryCsvFile, this.course.title+'_Extracted_MCs.csv')
      this.hideLoader()
      if (warnings && warnings.length > 0) {
        this.notifyWarning(warnings)
      } else {
        this.notifySuccess('Course Extract MC Successfully.')
      }
    },
    uploadMCMapping (){
      return this.$router.push({ name: 'microCompetencyMappingUpload' })
    },
    async downloadConversionDryRun () {
      this.showLoader()
      let response = await this.exportCourseConversionToCsv(this.courseId)
      this.hideLoader()
      let summaryCsvFile = response && response.fileContents ? response.fileContents : response
      let errors = response && response.error ? response.error : ''
      let warnings = response && response.warning ? response.warning : ''
      if (!summaryCsvFile || !summaryCsvFile.length || summaryCsvFile.length === 0) {
        return this.notifyFailure(errors)
      }
      this.writeFile(summaryCsvFile, this.course.title+'_Extract_MC_Check.csv')
      if (warnings && warnings.length > 0) {
        this.notifyWarning(warnings)
      } else {
        this.notifySuccess('Course Extract MC Dry Run Successfully Exported to Csv')
      }
    },
    async exportCourseCompetencyTree () {
      let response = await this.exportCourseTreeToCsv(this.courseId)
      let summaryCsvFile = response && response.fileContents ? response.fileContents : response
      let errors = response && response.error ? response.error : ''
      let warnings = response && response.warning ? response.warning : ''
      if (!summaryCsvFile || !summaryCsvFile.length || summaryCsvFile.length === 0) {
        return this.notifyFailure(errors)
      }
      this.writeFile(summaryCsvFile, this.course.title+'_competency_tree.csv')
      if (warnings && warnings.length > 0) {
        this.notifyWarning(warnings)
      } else {
        this.notifySuccess('Course Competency tree Successfully Exported to Csv')
      }
    },
    notifySuccess (text) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text,
        duration: 5000
      })
    },
    notifyFailure (text) {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text,
        duration: 5000
      })
    },
    notifyWarning (text) {
      this.$notify({
        group: 'notify',
        type: 'warn',
        title: '',
        text: text
      })
    },
    save () {
      this.showLoader()
      this.submitted = true
      this.course.plan = this.generatePlan(this.plan)
      this.saveCourseDetail(this.course).then((res) => {
        this.$emit('saved', JSON.parse(res.plan))
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Course "' + res.title + '" updated successfully.'
        })
        this.hideLoader()
        this.submitted = false
      })
    },

    done () {
      this.showLoader()
      this.submitted = true
      this.course.plan = this.generatePlan(this.plan)
      this.saveCourseDetail(this.course).then((res) => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Course "' + res.title + '" updated successfully.'
        })
        this.hideLoader()
        this.returnToDashboard()
      })
    },

    generatePlan (plan) {
      $.each(plan, (i, item) => {
        delete item.id
        if (item.type === 'LearningTopic') {
          if (item.children.length > 0) {
            this.generatePlan(item.children)
          }
        } else {
          delete item.children
          delete item.isDataRendered
          delete item.isStudentEditable
        }
      })
      return JSON.stringify(plan)
    },

    returnToDashboard () {
      let userPermission = this.permission.userPermission
      if (userPermission.studentHomeView) {
        return this.$router.push({ name: 'studentDashboard' })
      } else if (userPermission.instructorHomeView) {
        if (userPermission.adminHomeView) {
          let name = (this.isNuNavLogin) ? 'nunavAdminDashboard' : 'adminDashboard'
          return this.$router.push({ name: name })
        } else {
          return this.$router.push({ name: 'instructorDashboard' })
        }
      }
    },

    hideToc () {
      $('.page-content').addClass('hideToc').removeClass('showToc')
      $('.page-heading').addClass('hideToc').removeClass('showToc')
      this.loadLogDashboardActivity({action: 'clickHideToc', page: 'courseHeader', link: '', entityUuid: this.courseId})
    },

    showToc () {
      $('.page-heading').addClass('showToc').removeClass('hideToc')
      $('.page-content').addClass('showToc').removeClass('hideToc')
      this.loadLogDashboardActivity({action: 'clickShowToc', page: 'courseHeader', link: '', entityUuid: this.courseId})
    },
    generateLTIUrl (courseId) {
      let url = window.location.protocol + '//' + window.location.host +'/connect/processurl?courseid='+courseId
      return url
    },
    notifyUrlCopiedMessage (messageType) {
      setTimeout(() => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: messageType + ' Url is copied for LMS embedding.'
        })
      }, 0)
    },
		activateToc () {
			this.updateIsTocOpen(true)
		},
		deActivateToc () {
			this.updateIsTocOpen(false)
		},
    showCourseUnbundleModal (){
        this.$refs.courseUnbundleModal.show()
    },
    closeCourseUnbundleModal () {
      this.$refs.courseUnbundleModal.hide()
    },
    donotAllowForCourse (flagValue){
      if(!this.isInstructorLogin){
        return false
      }
      let donotAllowEdit = this.enabledFeatures['Instructor Permissions']
      if (!donotAllowEdit || !donotAllowEdit.enabled) {
        return false
      }
      if (donotAllowEdit.enabled) {
        let flags = donotAllowEdit.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === flagValue) {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    showLoader () {
      this.loading = true
      this.$refs.loadingModal.show()
    },

    hideLoader () {
      this.loading = false
      this.$refs.loadingModal.hide()
    },

    naviagteToCourseCuration () {
        if(this.course.version==='V2'){
          return this.$router.push({ name: 'courseCurationMC', params: { uuid: this.course.uuid } })
        }else{
          return this.$router.push({ name: 'courseCuration', params: { uuid: this.course.uuid } })
        }
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'topics': state => state.course.topics,
      'isTocOpen': state => state.course.isTocOpen,
      'continueLearning': state => state.course.continueLearning,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'permission': state => state.user.permission
    }),

    isSandboxUser: function () {
      var uObj = JSON.parse(localStorage.getItem('userobj'))
      if (uObj) {
        return this.sandboxUsers.includes(uObj.eMail)
      }
      return false
    },
    filteredModules (){
      let filterData = []
      $.each(this.modules, (index, module) => {
          if (module.subject === this.code1) {
            filterData.push(module)
          }
      })
      if(filterData[0]){
        this.code2 = filterData[0].module
      }
      return filterData
    },
    allowCopyLTILink () {
      let allowCopyLTILink = this.enabledFeatures['allowCopyLTILink']
      if (!allowCopyLTILink || !allowCopyLTILink.enabled) {
        return false
      }
      return allowCopyLTILink.enabled
    },
    allowDownloadCTree () {
      let allowDownloadCompetencyTree = this.enabledFeatures['allowDownloadCompetencyTree']
      if (!allowDownloadCompetencyTree || !allowDownloadCompetencyTree.enabled) {
        return false
      }
      return allowDownloadCompetencyTree.enabled
    },
    isOpenCourse () {
      if (this.course && (this.course.courseType === 'OPEN' || (this.course.courseType && this.course.courseType.includes('EXTERNAL_')))) {
        return true
      } else {
        return false
      }
    }
  }

}
</script>
<style scoped>
	.btn-container {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 8px;
	}

	.btn-container .create-section-menu {
		order: 1;
		margin: 0 !important;
		float: none !important;
	}

	.btn-container .btn,
	.btn-container button,
	.btn-container .btn_show_toc {
		margin: 0 !important;
		float: none !important;
	}

	.btn-container >>> .create-section-menu .dropdown-toggle,
	.btn-container >>> .create-section-menu .btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		height: auto;
		margin: 0 !important;
		float: none !important;
		overflow: visible;
		padding: 0 4px;
	}

	.showBtn {
		display:none;
	}
	.pg_hd .hd .hd_txt {
		margin-top: 5px;
  	margin-left: 20px;
	}
	.modal_popup_container .modal .modal-dialog {
		max-width: calc(100% - 300px) !important;
		width: calc(100% - 300px) !important;
	}
</style>



// WEBPACK FOOTER //
// src/app/course/components/CourseHeader.vue